module.exports = __webpack_public_path__ + "img/DK71827917.ade09643.png";